import { render, staticRenderFns } from "./searchDutyArea.vue?vue&type=template&id=54b71bf3&"
import script from "./searchDutyArea.vue?vue&type=script&lang=js&"
export * from "./searchDutyArea.vue?vue&type=script&lang=js&"
import style0 from "./searchDutyArea.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports